<template>
  <div class="section-container">
    <div class="main-container clearfix">
      <div class="menu">
        <div class="menu-item">
          <a class="database" @click="showCounserlor" href="javascript:;">业务顾问</a>
        </div>
        <div class="menu-item" v-show="loanTypeArr.length > 0">
          <a class="folder" href="javascript:;" :class="{'active': isOpen}" @click="isOpen = !isOpen">案例分享</a>
          <div class="sub-menu" v-show="isOpen">
            <div class="sub-menu-item" v-for="(item, index) in loanTypeArr" :key="item.id">
              <a :class="{'active': index === selectedIndex}" href="javascript:void(0);" @click="subMenuClick(item, index)">{{item.name}}</a>
            </div>
          </div>
        </div>
      </div>
      <div class="content">
        <ArticleList
          v-show="articleList.length > 0"
          :articleList="articleList"
          :show-copy-right="true"
          @item-click="articleClick" />
        <Loading
          v-show="articleList.length === 0"
          :height="100"
          :is-no-more="articleListNoMore"/>
      </div>
    </div>
    <div class="pagebox">
      <Pagination
        :count="count"
        :current-page="currentPage"
        :page-size="pageSize"
        @on-page-click="onPageClick"/>
    </div>
  </div>
</template>

<script>
  import Pagination from '@/components/combo/pagination'
  import Loading from '@/components/combo/loading'
  import ArticleList from '@/components/consultant/article-list'
  import Menubar from '@/components/combo/menubar'
  export default {
    components: {
      Pagination,
      ArticleList,
      Menubar,
      Loading
    },
    data () {
      return {
        isOpen: true,
        selectedIndex: 0,
        loanTypeId: '',
        loanTypeArr: [],
        currentPage: 1,
        count: 0,
        pageSize: 10,
        articleList: [],
        articleListNoMore: false
      }
    },
    created () {
      this.fetchData()
    },
    watch: {
      '$store.state.city' () {
        this.fetchData()
      }
    },
    methods: {
      fetchData () {
        this.getLoanTypeArr().then(() => {
          if (this.loanTypeArr.length > 0) { // 存在loanType时
            this.loanTypeId = this.loanTypeArr[0].id
            this.getArticlesByLoanType()
          } else { // 不存在loanType时
            this.loanTypeId = ''
            this.$router.replace('/consultant/counserlor')
          }
        })
      },
      getLoanTypeArr () {
        let vm = this
        return this.$http({
          url: '/getLoanTypeMap.jhtml',
          data: {
            cityNo: this.$store.state.city.code
          },
          done (result) {
            vm.loanTypeArr = [].concat(result)
          }
        })
      },
      showCounserlor () {
        this.$router.replace('/consultant/counserlor')
      },
      subMenuClick (sub, index) {
        this.selectedIndex = index
        this.currentPage = 1
        this.loanTypeId = sub.id
        this.getArticlesByLoanType()
      },
      articleClick (item) {
        window.open(`/consultant/article/${item.author}?articleId=${item.id}`)
        // this.$router.push(`/consultant/article/${item.author}?articleId=${item.id}`)
      },
      getArticlesByLoanType () {
        this.articleList = []
        this.articleListNoMore = false
        let vm = this
        this.$http({
          url: '/getMoreArticleByCounselor.jhtml',
          data: {
            loanType: vm.loanTypeId || '',
            isPage: 'y',
            pageNumber: vm.currentPage || 1,
            pageSize: vm.pageSize
          },
          done (articles, page) {
            setTimeout(() => {
              vm.articleList = articles
              vm.page = page || {}
              vm.count = page.count
              if (vm.articleList.length === 0) {
                vm.articleListNoMore = true
              }
            }, 200)
          }
        })
      },
      onPageClick (currentPage) {
        this.currentPage = currentPage
        this.getArticlesByLoanType()
      }
    }
  }
</script>

<style type="text/css" lang="stylus" scoped>
  @import '../../stylus/mixin'
  .section-container
    background none
  .main-container
    padding-top 36px
  .menu
    float left
    width 228px
    line-height 58px
    box-shadow 0px 1px 15px 3px rgba(0, 0, 0, 0.16)
    .menu-item
      background-color rgb(43, 158, 252)
      > a
        position relative
        color #fff
        display block
        border-left 4px solid rgb(43, 158, 252)
        border-top 1px solid rgb(71, 171, 253)
        height 58px
        font-size 16px
        background-color rgb(43, 158, 252)
        padding-left 60px
        text-decoration none
        &:hover, &.active
          border-left 4px solid rgb(255, 255, 255)
          background-color rgb(0, 132, 233)
        &:nth-child(0)
          border-top none
        &.database:before, &.folder:after, &.folder:before
          position absolute
          content ''
          display block
          height 18px
          top 20px
          background-repeat no-repeat
          background-position center
        &.database:before
          width 16px
          left 15px
          background-image url(/static/img/database.png)
        &.folder:after
          width 5px
          height 8px
          right 12px
          top 26px
          background-image url(/static/img/arrow.png)
          transition 0.3s
        &.folder.active:after
          transform rotate(90deg)
          -ms-transform rotate(90deg)
        &.folder:before
          width 20px
          left 15px
          background-image url(/static/img/folder.png)
    .sub-menu
      .sub-menu-item
        width 228px
        height 58px
        background-color rgb(71, 171, 253)
        >a
          position relative
          display block
          color #fff
          font-size 14px
          text-decoration none
          padding-left 60px
          &:hover, &.active
            background-color rgba(255, 255, 255, 0.3)
          &:before, &:after
            content ''
            position absolute
            display block
            border-radius 50%
            background-color rgba(255, 255, 255, 1)
          &:before
            width 6px
            height 6px
            left 24px
            top 26px
          &:after
            width 10px
            height 10px
            left 22px
            top 24px
            opacity 0.4
  .content
    float right
    padding-left 20px
    width 952px
    margin 0
  .pagebox
    padding 90px 0 80px
</style>




// WEBPACK FOOTER //
// case-share.vue?8b99e3b8